import Vue from 'vue/dist/vue.esm'
import QuickOrderForm from 'components/storefront/quick-order-form.vue'
import TaxonMessage from 'components/storefront/quick-order/taxon-message.vue'

export default function buildQuickOrderApp(element) {
  new Vue({
    el: element,
    components: {
      QuickOrderForm,
      TaxonMessage
    },
    data() {
      return {
        taxon: {}
      }
    },
    methods: {
      onTaxonLoaded(taxon) {
        this.taxon = taxon || {}
      }
    }
  })
}
